// removed by extract-text-webpack-plugin
module.exports = {"player":"BackgroundPlayer__player___1Z9Ro"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/interaction/children/resultsvisualization/childcomponents/BackgroundPlayer.scss
// module id = 802
// module chunks = 0